import { render } from "./AllPurchasing.vue?vue&type=template&id=7e56ba37"
import script from "./AllPurchasing.vue?vue&type=script&lang=js"
export * from "./AllPurchasing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__